import { _, React, classNames, withStyles, StyledProps, CentricTheme } from '@api'
import { withTheme } from '@material-ui/core';
import { TitleBarControls, TitleBarFilters } from './'

const styles = (theme: CentricTheme) => ({
  root:            {
    display:        'flex',
    justifyContent: 'flex-start',
    alignItems:     'center'
  },
  title:           {
    marginLeft: theme.spacing() * 2
  },
  verticalDivider: {
    borderRight: `1px solid #e1e1e1`,
    height:      64,
    margin:      `0px ${theme.spacing() * 2}px`
  }
})

interface MyProps extends StyledProps {
  controls?: React.ReactNode
  filters?: React.ReactNode
}

@(withStyles as any)(styles)
export class TitleBarControlAndFilter extends React.Component<MyProps> {
  static defaultProps = {}

  render() {
    const {className, classes, controls, filters} = this.props;

    return (
      <div className={classNames(classes.root, className)}>
        <TitleBarControls> {controls} </TitleBarControls>
        <div className={classes.verticalDivider}/>
        <TitleBarFilters>{filters}</TitleBarFilters>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/TitleBarControlAndFilter.tsx